import type { ClinicianRequest } from '../../API/services/ClinicianService';

const ClinicianInitialData: ClinicianRequest = {
  file: null as File | null,
  clinicianRequest: {
    userInfo: {
      id: 0,
      userBusinessId: '',
      firstName: '',
      lastName: '',
      preferredName: '',
      suffix: '',
      categoryId: 0,
      status: true,
      email: '',
      alternateEmail: '',
      phone: '',
      alternatePhone: '',
      gender: '0',
      dateOfBirth: '',
      maxConcurrentConsults: 0,
      notes: '',
    },
    providerDetails: {
      id: 0,

      zoomUserId: '',
      npi: '',
    },
    address: {
      id: 0,
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '0',
      postalCode: '',
      county: '',
    },
  },
};
export default ClinicianInitialData;
